import { Link } from 'react-router-dom';
import { getHotVideos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function FeaturedVideos() {
  const hotVideos = getHotVideos().slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100" aria-labelledby="featured-heading">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 id="featured-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              全网最热视频精选，每日更新不容错过
            </p>
          </div>
          <Link
            to="/category/recommended"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              thumbnail={video.thumbnail}
              duration={video.duration}
              views={video.views}
              rating={video.rating}
              tags={video.tags}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部热门推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}